import { apiJson, apiRaw } from '@/lib/http';
// Use shared helpers
const apiCall = <T = unknown>(endpoint: string, options: RequestInit = {}) => apiJson<T>(endpoint, options);

// Helper for file downloads uses raw response helper
const downloadApiCall = (endpoint: string, options: RequestInit = {}) => apiRaw(endpoint, options);

export interface ExportRequest {
  user_id?: string;
  project_id?: string;
  format: string;
  date_from?: string;
  date_to?: string;
}

export interface DeleteRequest {
  user_id?: string;
  project_id?: string;
  confirmation: string;
}

export interface BulkDeleteResponse {
  message: string;
  deletedCount: number;
  success: boolean;
}

export const exportDeleteService = {
  // Export memories
  async exportMemories(request: ExportRequest): Promise<void> {
    try {
      // Convert date strings to proper format for backend
      const exportRequest = {
        userId: request.user_id,
        projectId: request.project_id,
        format: request.format,
        dateFrom: request.date_from ? new Date(request.date_from).toISOString() : undefined,
        dateTo: request.date_to ? new Date(request.date_to).toISOString() : undefined,
      };

      const response = await downloadApiCall('/memoryfrontend/export', {
        method: 'POST',
        body: JSON.stringify(exportRequest),
      });

      // Get filename from Content-Disposition header or create a default one
      const contentDisposition = response.headers.get('Content-Disposition');
      let filename = `memory_export_${new Date().toISOString().slice(0, 10)}.${request.format.toLowerCase()}`;
      
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
        if (filenameMatch) {
          filename = filenameMatch[1];
        }
      }

      // Create blob and download
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error('Error exporting memories:', error);
      throw error;
    }
  },

  // Bulk delete memories
  async bulkDeleteMemories(request: DeleteRequest): Promise<BulkDeleteResponse> {
    try {
      const deleteRequest = {
        userId: request.user_id,
        projectId: request.project_id,
        confirmation: request.confirmation,
      };

      const response = await apiCall<BulkDeleteResponse>('/memoryfrontend/bulk-delete', {
        method: 'POST',
        body: JSON.stringify(deleteRequest),
      });

      return response;
    } catch (error) {
      console.error('Error bulk deleting memories:', error);
      throw error;
    }
  },
}; 